// import of a statemanager store. Adjust to meet component requirements.
import { useMainStore } from 'stores/main.store'
import { onMounted, onUpdated, ref } from 'vue'

export default {
    name: "PageControls",
    props: {
        label: {
            type: String,
            required: true
        },
        buttonLabel: {
            type: String,
            required: true
        },
        currentSize: {
            type: Number,
            requred: true
        },
        totalSize: {
            type: Number,
            required: true
        },
        callback: {
            type: Function,
            default: () => {},
            required: true
        }
    },
    setup(props) {
        const formatetLabel = ref("")

        const formatLabel = function() {
            formatetLabel.value = props.label
                .replace("{currentSize}", props.currentSize)
                .replace("{totalSize}", props.totalSize)
        }

        onMounted(() => formatLabel())
        onUpdated(() => formatLabel())

        return {
            formatetLabel
        }
    }
}